// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Kfdx","productName":"Table_productName__13Zky"};